<template>
  <div class="d-flex justify-content-between">
    <h6 v-if="!item.is_free">Certificado de<br> {{ item.workload }} Horas</h6>

    <h5 class="text-success" v-if="item.is_free"><b>Gratuito</b></h5>
    <h5 v-else-if="item.value_sale > 0">
      <small class="text-grey"><del>{{ item.value | formatMoney }}</del></small>&nbsp;
      <b class="text-success">{{ item.value_sale | formatMoney }}</b>
    </h5>
    <h5 class="text-success" v-else><b>{{ item.value | formatMoney }}</b></h5>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
    }
  }
}
</script>

<style>

</style>
